<div class="p-2 flex row justify-between">
    <div class="text-lg font-medium tracking-tight leading-6 truncate">
        CDFT Status
    </div>
    <div>
        <button mat-dialog-close>
            <ng-container [ngTemplateOutlet]="closedIcon"></ng-container>
        </button>
    </div>
</div>

<mat-dialog-content>
    <form [formGroup]="form" class="w-full grid grid-cols-1 gap-2">
     
        <mat-form-field class="custom-mat-form-field w-full">
            <mat-label>Status</mat-label>
            <mat-select matNativeControl formControlName="status">
                <!-- <mat-option value="Draft">Draft</mat-option>
                <mat-option value="Ready to Review">Ready to Review</mat-option> -->
                <!-- <mat-option value="Reviewed">Reviewed</mat-option> -->
                <mat-option value="Approved">Approved</mat-option>
                <mat-option value="Rejected">Rejected</mat-option>
            </mat-select>
        </mat-form-field>
        
        <mat-form-field class="w-full">
            <mat-label>Remarks</mat-label>
            <textarea
                matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="10"
                formControlName="remarks"
            ></textarea>
        </mat-form-field>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button class="btn btn-outline btn-error mx-4" mat-dialog-close>
        Cancel
    </button>
    <button class="btn btn-primary" (click)="update()">Update</button>
</mat-dialog-actions>

<ng-template #closedIcon>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-6 h-6"
    >
        <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 18 18 6M6 6l12 12"
        />
    </svg>
</ng-template>
